export default "__VITE_ASSET__BkYvoBSj__"